import React from "react";
import "./WristwatchRepair.css";
import { Helmet } from "react-helmet-async";

const title = "Wristwatch Repairs & Jewelry Cleaning";
const pageTitle = "Wristwatch Repairs & Jewelry Cleaning | Respected Solutions";
const metaDescription =
  "Professional luxury wristwatch repairs and expert jewelry cleaning at Respected Solutions. Restore brilliance, polish, and functionality to your valuables.";

const WristwatchRepair = () => {
  return (
    <section className="wristwatch-repair-container">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>

      <div
        className="wristwatch-repair-hero-slide"
        style={{
          backgroundImage: `url(/assets/images/rs/rolex-watch.jpg)`,
        }}
      >
        <div className="wristwatch-repair-hero-overlay">
          <div className="wristwatch-repair-hero-content">
            <h1>{title}</h1>
            <p>
              Bring your jewellery and luxury wristwatch back to its brilliance!
            </p>
          </div>
        </div>
      </div>

      <div className="wristwatch-repair-inner">
        <div className="wristwatch-repair-inner-content">
          <section className="wristwatch-repair-intro">
            <p>
              Valuable accessories naturally take scratches, dents, and wear
              from daily use. But don't let damaged or dull pieces sit
              forgotten, we offer a complete repair and cleaning service to
              bring your treasured items back to life.
            </p>
          </section>

          <section className="wristwatch-repair-professional">
            <h2>Professional Repairs</h2>
            <p>
              Our expert team handles everything from broken chains and clasps
              to reshaping rings and resetting stones. Every piece is treated
              with precision and care, so it's returned looking as flawless as
              possible.
            </p>
            <p>
              Damaged jewellery or wristwatch? Let Respected Solutions fix it!
            </p>
          </section>

          <section className="wristwatch-repair-cleaning">
            <h2>Expert Cleaning & Polishing</h2>
            <p>
              Jewellery & wristwatches can lose their sparkles over time. We
              restore shine using advanced cleaning technology, combined with
              hands-on detailing from our skilled staff. The result? Your pieces
              look fresh, polished, and vibrant again.
            </p>
            <p>
              Each item is handled with care and attention, ensuring it's
              returned in top condition.
            </p>
            <p>
              <strong>
                Experience the transformation: bring your valuables to Respected
                Solutions today!
              </strong>
            </p>
          </section>

          <div className="wristwatch-repair-seo-content">
            <h2>Watch Valuation & Appraisal Services</h2>
            <p>
              In addition to repairs and cleaning, we offer professional watch
              valuation Lagos and jewellery appraisal Lagos services. Whether
              you need car valuation for loan Lagos or want to understand how
              pawn loan works Nigeria, our team provides expert guidance. Learn
              about documents for pawn loan Nigeria, pawn interest rate Nigeria,
              loan repayment terms Nigeria, and find asset appraisal near me.
              Trust Respected Solutions for accurate valuations and transparent
              appraisal services across Lagos and Nigeria.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WristwatchRepair;
